export default __webpack_public_path__ + "locales/de/InfoPanel.json?hash=43411dea7b87e8450f417ed29ab0698f";